import React from "react";
import moment from "moment";
import { CierresAlmacenTable } from "./CierresAlmacenTable";
import { ComparativoMensualTable } from "./ComparativoMensualTable";
import { MensajeReporteSinDatos } from "./MensajeReporteSinDatos";
import { SeccionReporte } from "./SeccionReporte";
import { TIPO_SIN_ENVIOS } from "../helpers/tiposDiferenciaAcopio";
import { ResumenConsumoTable } from "../../components/ResumenConsumoTable";
import { ResumenReporte } from "../../../InventariosAlmacen/pages/ReporteInventarios/tabs/ResumenCierresTab/components/ResumenReporte";

const titularRango = (rango) =>
    `del ${moment(rango.fecha_inicial).format("DD/MM/YYYY")} al ${moment(
        rango.fecha_final,
    ).format("DD/MM/YYYY")}`;

// Los tres reportes en el orden en que el cliente los lee en su archivo: las
// dos fuentes primero y el cuadro que las enfrenta al final, con la diferencia
// acopio de cada periodo justo antes de él, que cada pantalla arma a su manera.
// Los cierres de almacén llevan el rango de sus periodos; el consumo va por
// semanas, que ya se listan en su tabla.
// Las advertencias de traslados solo aplican a un cierre que todavía no se
// registra, así que un cierre registrado las deja vacías
export const SeccionesComparativo = ({
    comparativo,
    pendientesTraslados,
    descripcionComparativo,
    children,
}) => {
    const cierresAlmacen = comparativo.resumen_cierres_almacen;
    const diferenciasAcopio = comparativo.diferencias_acopio_por_periodo;

    const periodosSinEnvios = diferenciasAcopio
        .filter((periodo) => periodo.tipo_diferencia_acopio === TIPO_SIN_ENVIOS)
        .map((periodo) => periodo.periodo_id);

    return (
        <React.Fragment>
            <SeccionReporte
                colapsable
                titulo={
                    cierresAlmacen
                        ? `Cierres de inventario de almacén ${titularRango(
                              comparativo.rango_periodos,
                          )}`
                        : "Cierres de inventario de almacén"
                }
                descripcion="Proporciona la materia prima y el reproceso de los métodos 1 y 2 para el comparativo."
            >
                {cierresAlmacen ? (
                    <React.Fragment>
                        <ResumenReporte
                            totalGlobal={cierresAlmacen.total_global}
                        />
                        <CierresAlmacenTable
                            inventarios={cierresAlmacen.inventarios}
                            periodosSinEnvios={periodosSinEnvios}
                        />
                    </React.Fragment>
                ) : (
                    <MensajeReporteSinDatos mensajeError="El cierre no abarca ningún periodo de inventario de almacén cerrado" />
                )}
            </SeccionReporte>

            <SeccionReporte
                colapsable
                titulo="Consumo de producción por semana"
                descripcion="Proporciona la materia prima y el reproceso del método 3, y la producción obtenida, para el comparativo."
            >
                <ResumenConsumoTable resumen={comparativo.resumen_consumo} />
            </SeccionReporte>

            {diferenciasAcopio.length > 0 && children}

            <SeccionReporte
                titulo="Comparativo de producción"
                descripcion={descripcionComparativo}
            >
                {comparativo.filas.length > 0 ? (
                    <ComparativoMensualTable
                        comparativo={comparativo}
                        pendientesTraslados={pendientesTraslados}
                    />
                ) : (
                    <MensajeReporteSinDatos
                        mensajeError={
                            "El comparativo se calcula cuando el cierre tiene " +
                            "al menos una semana, todas sus semanas están " +
                            "completas y abarca al menos un periodo de " +
                            "inventario de almacén con envíos a producción " +
                            "del producto padre"
                        }
                    />
                )}
            </SeccionReporte>
        </React.Fragment>
    );
};
